// import AWS from 'aws-sdk'; // Import the entire SDK
// import S3 from 'aws-sdk/clients/s3'; // Import only the S3 client
import toast from 'react-hot-toast';
import axios from 'axios';
const baseURL=  process.env.REACT_APP_BASE_URL

// export const uploadFileToS3 = async (file, setUploadPercent) => {
//   const S3_BUCKET = "peerscroller"; // Replace with your bucket name
//   const REGION = "eu-west-2"; // Replace with your region

//   AWS.config.update({
//     accessKeyId: "AKIAQ3EGWBDCAQYL4TRU",
//     secretAccessKey: 'RM/F8Qp/RGhsUmwkEtgUxBMgaqoLFBYOhxJXM9GH'
//   });

//   const s3 = new S3({
//     params: { Bucket: S3_BUCKET },
//     region: REGION,
//   });

//   const timestamp = Date.now();
//   const folderName = "uploads/admin"; // Specify your folder name here
//   const uniqueFileName = `${folderName}/${timestamp}_${file.name}`;
//   const params = {
//     Bucket: S3_BUCKET,
//     Key: uniqueFileName,
//     Body: file,
//   };

//   try {
//     const upload = s3.upload(params)
//     upload.on('httpUploadProgress', (progressEvent) => {
//       const { loaded, total } = progressEvent;
//       const percentage = Math.round((loaded / total) * 100);
//       setUploadPercent(percentage)
//     });
//     const result = await upload.promise();

//     return result.Location // Return the file URL
//   } catch (error) {
//     throw new Error("Error uploading file: " + error.message);
//   }
// };


export const uploadFileToS3 = async (file, setUploadPercent) => {
  const API_URL = '/content/file';
  const formData = new FormData();
  formData.append('image', file); // Changed the key to 'video'

  try {
    const response = await axios.post(`${baseURL}${API_URL}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      onUploadProgress: (progressEvent) => {
        if (setUploadPercent) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadPercent(percentCompleted); // Update upload progress
        }
      },
    });

    if (response.data.statusCode === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error uploading content:', error.response?.data || error.message);
    throw error; // Re-throw the error to handle it in the calling function
  }
};

// export const uploadVideoToS3 = async (file, setUploadPercent, setFieldValue, MobileURL) => {
//   const S3_BUCKET = "peerscroller"; // Replace with your bucket name
//   const REGION = "eu-west-2"; // Replace with your region

//   AWS.config.update({
//     accessKeyId: "AKIAQ3EGWBDCAQYL4TRU",
//     secretAccessKey: 'RM/F8Qp/RGhsUmwkEtgUxBMgaqoLFBYOhxJXM9GH'
//   });

//   const s3 = new S3({
//     params: { Bucket: S3_BUCKET },
//     region: REGION,
//   });

//   const timestamp = Date.now();
//   const extension = file.name.substring(file.name.lastIndexOf('.') + 1);
//   const folderName = "uploads/admin/videos"; // Specify your folder name here
//   // const uniqueFileName = `${folderName}/${timestamp}_${file.name}`;
//   const uniqueFileName = `uploads/${timestamp}.${extension}`;
//   const params = {
//     Bucket: S3_BUCKET,
//     Key: uniqueFileName,
//     Body: file
//   };

//   try {
//     const upload = s3.upload(params)
//     upload.on('httpUploadProgress', (progressEvent) => {
//       const { loaded, total } = progressEvent;
//       const percentage = Math.round((loaded / total) * 100);
//       setUploadPercent(percentage)
//     });
//     const result = await upload.promise();
//     setFieldValue(MobileURL, `https://peerscroller-hls.s3.eu-west-2.amazonaws.com/uploads/video-hls/${timestamp}.m3u8`)
//     return result.Location // Return the file URL
//   } catch (error) {
//     throw new Error("Error uploading video: " + error.message);
//   }
// };







export const uploadVideoToS3 = async (file, setUploadPercent, setFieldValue, MobileURL) => {
  const API_URL = '/content/upload';
  const formData = new FormData();
  formData.append('video', file); // Changed the key to 'video'

  try {
    const response = await axios.post(`${baseURL}${API_URL}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      onUploadProgress: (progressEvent) => {
        if (setUploadPercent) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadPercent(percentCompleted); // Update upload progress
        }
      },
    });

    if (response.data.statusCode === 200) {
      // Update MobileURL or setFieldValue if applicable
        setFieldValue(MobileURL, response.data.data.streaming_url); // Assuming `fileUrl` is returned
      return response.data;
    }
  } catch (error) {
    console.error('Error uploading content:', error.response?.data || error.message);
    throw error; // Re-throw the error to handle it in the calling function
  }
};





export const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};






export const truncateText = (text, wordLimit) => {
  if (!text) return 'N/A';
  const words = text.split(' ');
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
  }
  return text;
};


export const truncateTextManageContent = (text, wordLimit, charLimit = 30) => {
  if (!text) return 'N/A';
  
  const words = text.split(' ');
  let truncated = words.slice(0, wordLimit).join(' ');

  // If after slicing it is still too long (like because of a long URL)
  if (truncated.length > charLimit) {
    truncated = truncated.substring(0, charLimit) + '...';
  }

  return truncated;
};


// export const uploadStudentCSV = async (file) => {
//   const reader = new FileReader();
//   const requiredKeys = ['username', 'group', 'email', 'year', 'firstname', 'surname'];

//   return new Promise((resolve, reject) => {
//     reader.onload = function (e) {
//       const text = e.target.result;

//       // Detect the delimiter based on most frequent occurrences in the first line
//       const delimiters = [',', ';', '\t'];
//       let delimiter = ',';
//       let maxCount = 0;

//       delimiters.forEach((d) => {
//         const count = (text.split('\n')[0].match(new RegExp(d, 'g')) || []).length;
//         if (count > maxCount) {
//           maxCount = count;
//           delimiter = d;
//         }
//       });

//       // Split the CSV into lines
//       const lines = text.split('\n').filter(Boolean);

//       if (lines.length > 1) {
//         // Extract headers
//         const headers = lines[0].split(delimiter).map((header) => header.trim().toLowerCase());

//         // Check if the required headers are present
//         const hasRequiredHeaders = requiredKeys.every(key => headers.includes(key));

//         if (hasRequiredHeaders) {
//           const data = lines.slice(1).map(line => {
//             const values = line.split(delimiter).map(value => value.trim());
//             const record = {};

//             headers.forEach((header, index) => {
//               if (requiredKeys.includes(header)) {
//                 record[header] = values[index];
//               }
//             });

//             return record;
//           });

//           resolve(data);
//         } else {
//           reject(new Error(`Missing required headers: ${requiredKeys.join(', ')}`));
//         }
//       } else {
//         reject(new Error('No data found in the CSV'));
//       }
//     };

//     reader.onerror = () => {
//       reject(new Error('Failed to read file'));
//     };

//     reader.readAsText(file);
//   });
// };



export const uploadStudentCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'username', 'email', 'year' ];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [',', ';', '\t'];
      let delimiter = ',';
      let maxCount = 0;

      // Detect the correct delimiter
      delimiters.forEach((d) => {
        const count = (text.split('\n')[0].match(new RegExp(d, 'g')) || []).length;
        if (count > maxCount) {
          maxCount = count;
          delimiter = d;
        }
      });

      const lines = text.split('\n').filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((header) => header.trim().toLowerCase().replace(/^"|"$/g, '')); // Remove surrounding quotes
        // Debugging outputs

        const hasRequiredHeaders = requiredKeys.every((key) => headers.includes(key));

        if (hasRequiredHeaders) {
          const data = [];
          const usernameCount = {}; // Object to track how many times a username has been used

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(delimiter).map((value) => value.trim().replace(/^"|"$/g, '')); // Remove quotes from values
            const record = {};

            headers.forEach((header, index) => {
              if (requiredKeys.includes(header)) {
                record[header] = values[index];
              }
            });

            if (record.year) {
              const year = parseInt(record.year, 10);
              if ([7, 8, 9].includes(year)) {
                record.group = 3;
              } else if ([10, 11, 12].includes(year)) {
                record.group = 4;
              }
            }

            // Handle both user-provided and auto-generated usernames
            let baseUsername;
            if (record.username) {
              baseUsername = record.username.toLowerCase().replace(/[^a-z0-9]/gi, '');
            } else if (record.firstname && record.surname) {
              baseUsername = `${record.firstname}${record.surname}`.toLowerCase().replace(/[^a-z0-9]/gi, '');
            }

            if (baseUsername && baseUsername.length > 15) {
              baseUsername = baseUsername.substring(0, 15); // Maximum username length
            }

            if (baseUsername) {
              let newUsername = baseUsername;

              if (usernameCount[baseUsername]) {
                usernameCount[baseUsername]++;
                newUsername = `${baseUsername}${usernameCount[baseUsername]}`;
              } else {
                usernameCount[baseUsername] = 1;
              }

              record.username = newUsername;
            }

            if (!record.email) {
              toast.error(`One of the records is missing an email.`);
              resolve([]);
              return;
            }

            data.push(record);
          }

          resolve(data);
        } else {
          const missingHeaders = requiredKeys.filter((key) => !headers.includes(key));
          reject(new Error(`Missing required headers: ${missingHeaders.join(', ')}`));
        }
      } else {
        reject(new Error('No data found in the CSV'));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};

export const uploadTeacherCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'email', 'department'];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      let text = e.target.result;

      // Remove BOM and normalize line endings
      text = text.replace(/^\uFEFF/, '').replace(/\r\n/g, '\n');

      // Detect delimiter
      const delimiters = [',', ';', '\t'];
      const delimiter = delimiters.find((d) => text.includes(d)) || ',';

      const lines = text.split('\n').map((line) => line.trim()).filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((header) =>
            header.trim().toLowerCase().replace(/^"|"$/g, '') // Strip quotes
          );

        const hasRequiredHeaders = requiredKeys.every((key) => headers.includes(key));

        if (!hasRequiredHeaders) {
          toast.error(`Missing required headers: ${requiredKeys.join(', ')}`);
          resolve([]);
          return;
        }

        const data = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i]
            .split(delimiter)
            .map((value) => value.trim().replace(/^"|"$/g, '')); // Also strip quotes from values

          if (values.length !== headers.length) continue; // Skip malformed rows

          const record = {};
          headers.forEach((header, index) => {
            if (requiredKeys.includes(header)) {
              record[header] = values[index];
            }
          });

          if (!record.email) {
            toast.error(`Record on line ${i + 1} is missing an email.`);
            resolve([]);
            return;
          }

          data.push(record);
        }

        resolve(data);
      } else {
        toast.error('No data found in the CSV');
        resolve([]);
      }
    };

    reader.onerror = () => {
      toast.error('Failed to read file');
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};



export function convertTime(minutes) {
  const hours = Math.floor(minutes / 60);  // Get the hours
  const remainingMinutes = minutes % 60;   // Get the remaining minutes

  if (hours > 0 && remainingMinutes > 0) {
    return `${hours}h ${remainingMinutes}m`;  // "Xh Ym"
  } else if (hours > 0) {
    return `${hours}h`;  // Only hours
  } else {
    return `${remainingMinutes}m`;  // Only minutes
  }
}

export const constructQueryString = (obj) => {
  if (obj) {
    const queryString = Object.keys(obj)
      .filter(key => obj[key] !== "" && obj[key] !== null && obj[key] !== undefined)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
    return queryString;
  } else {
    return ""
  }
}

const normalizeRoute = (route = "") => `${route}`.replace(/^\/+/, "");

export const buildDetailNavigationPath = ({
  detailPath,
  returnRoute,
  currentSearch = "",
  currentPage = 1,
}) => {
  const queryParams = new URLSearchParams();
  const normalizedRoute = normalizeRoute(returnRoute);
  const normalizedSearch = `${currentSearch || ""}`.replace(/^\?/, "");

  queryParams.set("returnPage", `${currentPage}`);

  if (normalizedRoute) {
    queryParams.set("returnRoute", normalizedRoute);
  }

  if (normalizedSearch) {
    queryParams.set("returnQuery", normalizedSearch);
  }

  return `${detailPath}?${queryParams.toString()}`;
};

export const resolveReturnUrl = ({
  search = "",
  fallbackRoute = "",
  fallbackPage = "1",
}) => {
  const queryParams = new URLSearchParams(search);
  const returnPage = queryParams.get("returnPage") || `${fallbackPage}`;
  const returnRoute = normalizeRoute(
    queryParams.get("returnRoute") || fallbackRoute,
  );
  const returnQuery = queryParams.get("returnQuery") || "";

  if (returnQuery && returnRoute) {
    return `/${returnRoute}?${returnQuery}`;
  }

  if (returnRoute) {
    return `/${returnRoute}?page=${returnPage}`;
  }

  return `?page=${returnPage}`;
};

const statusCountKeys = {
  Active: ["active"],
  Inactive: ["inActive", "inactive"],
  Created: ["created", "Created"],
  Blocked: ["blocked", "Blocked"],
};

export const getFilteredPaginationTotal = ({
  response,
  rows = [],
  status = "",
  currentPage = 0,
  hasFilters = false,
  fallbackKey = "total",
}) => {
  const matchedStatusKeys = statusCountKeys[status] || [];

  for (const key of matchedStatusKeys) {
    const totalForStatus = Number(response?.[key]);
    if (Number.isFinite(totalForStatus)) {
      return totalForStatus;
    }
  }

  if (
    hasFilters &&
    currentPage === 0 &&
    Array.isArray(rows) &&
    rows.length === 0
  ) {
    return 0;
  }

  const fallbackTotal = Number(response?.[fallbackKey]);
  if (Number.isFinite(fallbackTotal)) {
    return fallbackTotal;
  }

  return Array.isArray(rows) ? rows.length : 0;
};




 // Function to filter records based on the specified fields
  export const filteredRecords = (records , fieldsToExport) => {
  return records.map(record => {
    const filteredRecord = {};
    fieldsToExport.forEach(field => {
      filteredRecord[field] = record[field]; // Only include selected fields
    });
    return filteredRecord;
  });
};



// export const getQueryParams = (search) => {
//   const params = new URLSearchParams(search);
//   const queryObject = {};
//   for (const [key, value] of params.entries()) {
//     queryObject[key] = value === "undefined" ? "" : value || ""
//   }
//   return queryObject;
// };



export const getQueryParams = (search) => {
  const params = new URLSearchParams(search);
  const queryObject = {
    school :"",
     Year :"",
      group:"" , 
      sortKey:"",
     sortOrder:"",
    selectedCategory:"" ,
    mostViewed:"",
    mostLiked :"",
    dateFormat:"",
    searchkey:"",
    searchKey:"",
    status:"",
    manager:"",
    check:"",
    startDate:"",
    endDate:"",
    returnQuery:"",
    gender:"",
    user:"",
    presenterId:"",
    sortBy:""
  };
  for (const [key, value] of params.entries()) {
    queryObject[key] = value ?? ""; // Ensures empty string for missing values
  }
  return queryObject;
};


export const serialNumber = (currentPage, limit, index) => {
  return (currentPage - 1) * limit + index + 1;
};



export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
